import { getRequestContext } from './server/request-context';

export function getStaticData<T extends Excite.ContentApi.IDynamicData>(type?: string) {
  return __BROWSER__
    ? (window.INITIAL_DATA.staticData?.find(x => x.type === type)?.data as T)
    : (getRequestContext().initialData?.clientData.staticData?.find(x => x.type === type)?.data as T);
}

export function useStaticData<TData extends Excite.ContentApi.IDynamicData>(type?: string) {
  return getStaticData<TData>(type);
}
